
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-4fa3adf6\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!postcss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Welfare.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Welfare.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-4fa3adf6\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Welfare.vue"),
  /* scopeId */
  "data-v-4fa3adf6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/sectionWork/Welfare.vue
// module id = 661
// module chunks = 0